import {BaseEventProxy} from '@projectstorm/react-canvas-core'

export const isMoving = (event?: BaseEventProxy) => {
  return !!event && ['positionChanged', 'offsetUpdated', 'zoomUpdated'].includes(event.function)
}
